import { useTranslation } from "react-i18next";
import { Flex, Spin } from "antd";
import { AppButton, AppInput, AppRadio, AppText, RadioGroup } from "@/shared/Components";
import { usePaymentForm } from "@/features/payment-form/model";
import type { FlowType } from "@/features/payment-form/model";
import { TariffOptionView } from "../components";
import { getSafeLocalizedValue } from "../../model/utils";
import styles from "./styles.module.scss";

type PaymentFormProps = {
  flowType: FlowType;
};

export const PaymentForm = ({ flowType }: PaymentFormProps) => {
  const { t } = useTranslation();

  const { state, methods } = usePaymentForm(flowType);

  const {
    isFetching,
    tariffsList,
    selectedTariff,
    selectedTariffOptions,
    discountCode,
    price,
    priceIsFetching,
    discountHasError,
  } = state;
  const {
    handleChangeRadio,
    handleChangeOptionItem,
    handleApplyDiscountCode,
    handleChangeDiscountCode,
    fetchPaymentUrl,
  } = methods;

  if (isFetching) {
    return <Spin />;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("registrationPage.paymentStep.choosePlan")}</h1>
      <RadioGroup
        value={selectedTariff?.tariffPlanId}
        defaultValue={tariffsList[0].value}
        onChange={handleChangeRadio}
      >
        {tariffsList.map((tariff) => (
          <AppRadio value={tariff.value} key={tariff.value} className={styles.radio}>
            {tariff.label}
          </AppRadio>
        ))}
      </RadioGroup>
      <AppText type="secondary">
        {getSafeLocalizedValue(selectedTariff?.localizedDescription, selectedTariff?.description)}
      </AppText>
      <Flex gap={12} vertical>
        {selectedTariff?.options.map((option) => (
          <TariffOptionView
            key={option.id}
            option={option}
            selectedTariffOptions={selectedTariffOptions}
            handleChangeOptionItem={handleChangeOptionItem}
          />
        ))}
      </Flex>
      <Flex gap={8} className={styles.promo}>
        <AppInput
          placeholder={t("registrationPage.paymentStep.promoPlaceholder")}
          value={discountCode}
          onChange={handleChangeDiscountCode}
          status={discountHasError ? "error" : undefined}
          className={styles["registration-input"]}
        />
        <AppButton type="link" onClick={handleApplyDiscountCode}>
          {t("registrationPage.paymentStep.apply")}
        </AppButton>
      </Flex>
      <AppButton
        type="primary"
        loading={priceIsFetching}
        disabled={priceIsFetching}
        onClick={fetchPaymentUrl}
      >
        {`${t("registrationPage.paymentStep.pay")} ${price}`}
      </AppButton>
    </div>
  );
};
